import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from "../../Global/Loader";

const SignupTrendChart = ({ filters = {} }) => {
  const [signupData, setSignupData] = useState([["Month", "M-Web", "Web", "App"]]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    fetchSignupData();
  }, [filters]);

  const fetchSignupData = async () => {
    setLoading(true);
    setError(null);
    setHasData(false);

    try {
      const response = await cdpService.getSignupTrend(filters);

      if (response.data.success && response.data.data.signupTrend.length > 0) {
        const trendData = response.data.data.signupTrend.map((item) => [
          new Date(item.month),
          Math.max(0, item.device_data?.mweb || 0),
          Math.max(0, item.device_data?.web || 0),
          Math.max(0, item.device_data?.app || 0),
        ]);

        setSignupData([["Month", "M-Web", "Web", "App"], ...trendData]);
        setHasData(true);
      } else {
        setSignupData([["Month", "M-Web", "Web", "App"]]); // Reset to headers
      }
    } catch (error) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const options = {
    curveType: "function",
    legend: { position: "bottom" },
    height: 350,
    hAxis: { title: "Month", format: "MMM yyyy" },
    vAxis: { title: "Signups", minValue: 0, viewWindow: { min: 0 } },
  };

  if (loading) return <Loader />;
  if (error) return <p className="text-red-500">{error}</p>;
  if (!hasData) return <p className="text-gray-500 text-center">No data available</p>;

  return (
    <Chart
      chartType="LineChart"
      width="100%"
      height="350px"
      data={signupData}
      options={options}
    />
  );
};

export default SignupTrendChart;
